/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-30 11:20:17
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-30 11:21:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/service/modal.service.ts
 */
import { useState } from 'react';

function useModalService() {
  const [visible, setVisible] = useState(false);

  return {
    visible,
    setVisible,
  };
}

export default useModalService;
